export default __webpack_public_path__ + "static/media/dr-priya-prem.a07965c7.jpg";